namespace app {
	export class LicensePlanController {
		constructor(
			private AccountService: AccountService,
			private LicensePlanService: LicensePlanService,
			private account: Account,
			private license_plans: LicensePlan[]) { }
	}
	angular.module("app").controller("LicensePlanController", LicensePlanController);
}